import Image from "next/image";
import { IoMdTime } from "react-icons/io";
// import { IoLocationOutline } from "react-icons/io5";
import { MdOutlineCalendarToday } from "react-icons/md";
import styled from "styled-components";
import { ButtonStyledComponent } from "components/button/button.style";
import { TicketIcon, SchoolIcon } from "components/svgs";
import { ActionButtons } from "styles/bootcamp/bootcamp";
import childImg from "../../public/images/africafest.png";

const parentCTALink =
   "https://docs.google.com/forms/d/e/1FAIpQLSdoPhpksu_ELUt8aRg9aZAveKRQ-25GLIvCfcaN8Dq3Y5WfHw/viewform";
const schoolCTALink =
   "https://docs.google.com/forms/d/e/1FAIpQLSdApwh6cz0Kwynng1y-zko83J543Yyy9dYPfV5AW-EU7NxTtA/viewform";

const HeroSection: React.FC<any> = () => {
   return (
      <HeroContainer_SC
         image1="/images/afredfest/neon-bg.png"
         image2="/images/afredfest/star-bg.png"
      >
         <LogoContainer_SC>
            <img src="/icons/africa-fest-2.png" alt="africa-fest-logo" />
         </LogoContainer_SC>
         <HeroCopy_SC>
            <h1>Africa Education Fest UK 2025</h1>
            <p>
               Empowering the next generation: Navigating Africa heritage and global education in a
               changing world.
            </p>
         </HeroCopy_SC>
         <HeroActionBtns>
            <ButtonStyledComponent
               as={"a"}
               href={parentCTALink}
               style={{
                  background: "linear-gradient(to right, #CE04F1, #77028B)",
                  color: "white",
                  borderRadius: "35px",
               }}
               variant="unstyled"
               size={"small"}
            >
               <span style={{ paddingRight: "8px" }}>
                  <TicketIcon />
               </span>
               Register to Attend
            </ButtonStyledComponent>
            <ButtonStyledComponent
               style={{ borderRadius: "35px", color: "#b3b3b3", borderColor: "#b3b3b3" }}
               variant="outline-white"
               as={"a"}
               href={schoolCTALink}
               size={"small"}
            >
               <span style={{ paddingRight: "8px" }}>
                  <SchoolIcon />
               </span>
               showcase your institution
            </ButtonStyledComponent>
         </HeroActionBtns>
         <HeroImage_SC>
            <Image src={childImg} alt="child-img" layout="fill" objectFit="cover" />
            {/* <img src="/images/africafest.png"  /> */}
         </HeroImage_SC>
         <EventVenueCard_SC>
            {/* <p>
               <span>
                  <IoLocationOutline size={24} style={{ marginRight: "8px" }} />
               </span>
               <span>Millennium Gloucester Hotel, London Kensiongton</span>
            </p> */}
            <p>
               <span>
                  <MdOutlineCalendarToday size={18} style={{ marginRight: "8px" }} />
               </span>
               <span>Saturday 12th Febuary 2025</span>
            </p>
            <p>
               <span>
                  {" "}
                  <IoMdTime size={18} style={{ marginRight: "8px" }} />
               </span>
               <span>12PM Prompt</span>
            </p>
         </EventVenueCard_SC>
      </HeroContainer_SC>
   );
};

const HeroContainer_SC = styled.section<{ image1: string; image2: string }>`
   background-image: url(${(props) => props.image1}), url(${(props) => props.image2});
   background-position: 30% -65px, center center; // Position both images
   background-repeat: no-repeat, no-repeat; // Avoid image repetition
   background-size: cover, contain; // Cover for the first image, contain for the second (adjust as needed)
   position: relative;
   width: 100%;
   background-color: black;
   min-height: 100vh;
   padding: 0 2rem;
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   @media screen and (min-width: 768px) {
      align-items: center;
      background-position: 0 35%, center center; // Position both images
   }
`;

const LogoContainer_SC = styled.div`
   position: absolute;
   top: 2rem;
   left: 2rem;
   max-width: 200px;
   img {
      width: 100%;
   }
   @media screen and (min-width: 768px) {
      top: 4rem;
      left: 4rem;
   }
`;

const HeroCopy_SC = styled.div`
   margin-top: 15rem;
   text-align: left;

   h1 {
      font-size: 24px;
      font-family: "Millik";
      margin: 2rem 0;
      color: white;
      font-weight: 700;
   }
   p {
      font-size: 14px;
      color: white;
      margin: 1rem 0;
      /* max-width: 30px; */
   }
   @media screen and (min-width: 768px) {
      text-align: center;
      h1 {
         font-size: 44px;
         margin: 2rem 0;
      }
      p {
         font-size: 18px;
         max-width: 540px;
         text-align: center;
         margin: 2rem auto;
      }
   }
`;

const HeroActionBtns = styled(ActionButtons)`
   align-items: flex-start;
   margin: 1rem 0;
`;

const HeroImage_SC = styled.div`
   position: relative;
   width: 100%;
   max-width: 400px;
   margin: 0;
   flex-grow: 1;
   aspect-ratio: 1/1;
   img {
      width: 100%;
      height: auto;
      transform: translateY(4%);
   }
`;

const EventVenueCard_SC = styled.div`
   position: absolute;
   bottom: 0px;
   left: 0px;
   background: linear-gradient(to right, #2d163d, #100e13);
   color: white;
   border-top-right-radius: 12px;
   padding: 1rem;
   width: 300px;
   max-width: 100%;
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   p {
      margin: 0.5rem 0;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
   }
   @media screen and (min-width: 768px) {
      padding: 2.5rem;
      width: 375px;
      p {
         font-size: 16px;
         font-weight: 500;
      }
   }
`;

export { HeroSection };
